<template>
  <div id="printPrescription" class="printPrescription">
    <div class="row-me center-all title">
      <span style="font-size: 20px;">调配单</span>
    </div>
    <div class="row-me flex-end2" style="margin-top: -30px;">
      <div class="row-me row-center" style="margin-bottom: 10px;">
        <div style="margin-right: 30px;">接方时间：{{ detailItem.createTime }}</div>
        <div>打印时间：{{ time }}</div>
      </div>
      <div class="flex1"></div>
      <svg id="barcode"></svg>
    </div>
    <div class="line-black" style="margin-bottom: 5px;"></div>
    <div class="row-me row-center flex-sb width100Per">
      <div style="width: 23%;">医院名称：{{ detailItem.hospitalName }}</div>
      <div style="width: 23%;">机构名称：{{ detailItem.mechName }}</div>
      <div style="width: 19%;">姓名：{{ detailItem.patientName }}</div>
      <div style="width: 15%;">性别：{{ detailItem.patientSex }}</div>
      <div style="width: 20%;">年龄：{{ detailItem.patientAge }}</div>
    </div>
    <div class="row-me row-center flex-sb width100Per">
      <div style="width: 23%;">处方订单号：{{ detailItem.orderNo }}</div>
      <div style="width: 23%;">开方医生：{{ detailItem.doctorName }}</div>
      <div style="width: 19%;">包装量：{{ detailItem.packageNums }}</div>
      <div style="width: 15%;" v-if="Number(detailItem.type)===1">频次：{{ detailItem.oneDoseNums }}</div>
      <div style="width: 15%;" v-else>次数：{{ detailItem.frequency }}</div>
      <div style="width: 20%;">服用方式:{{ detailItem.takeMethod }}</div>
    </div>
    <!--汤剂-->
    <div class="row-me row-center flex-sb width100Per"
         v-if="detailItem.val==='t'||detailItem.val==='d'||detailItem.val==='z'">
      <div style="width: 23%;">
        加工类型：<span style="font-size: 20px;">{{ detailItem.processType }}
        &nbsp;{{ detailItem.isDecoction ? '代煎' : '自煎' }}</span>
      </div>
      <div style="width: 23%;">剂数：<span style="font-size: 20px;">{{ detailItem.doseNums }}</span></div>
      <div style="width: 19%;">快递类型：{{
          detailItem.deliveryType === 1 ? '到付' : detailItem.deliveryType === 2 ? '月结' : detailItem.deliveryType === 0 ? '寄付' : ''
        }}
      </div>
      <div style="width: 35%;">药品重量(g)：{{ detailItem.totalWeight }}</div>
    </div>
    <!--颗粒剂-->
    <div class="row-me row-center flex-sb width100Per" v-else-if="detailItem.val==='k'">
      <div style="width: 23%;"><!--丸剂、散剂、颗粒剂、膏剂都显示代煎-->
        加工类型：<span style="font-size: 20px;">{{ detailItem.processType }}&nbsp;代煎</span>
      </div>
      <div style="width: 23%;">剂数：<span style="font-size: 20px;">{{ detailItem.doseNums }}</span></div>
      <div style="width: 19%;">快递类型：{{
          detailItem.deliveryType === 1 ? '到付' : detailItem.deliveryType === 2 ? '月结' : detailItem.deliveryType === 0 ? '寄付' : ''
        }}
      </div>
      <div style="width: 35%;">药品重量(g)：{{ detailItem.totalWeight }}</div>
    </div>
    <!--其他剂型-->
    <div class="row-me row-center flex-sb width100Per" v-else>
      <div style="width: 23%;" v-if="detailItem.val==='wy'"><!--中医外治-->
        加工类型：<span style="font-size: 20px;">{{ detailItem.processType }}</span>
      </div>
      <div style="width: 23%;" v-else><!--丸剂、散剂、颗粒剂、膏剂都显示代煎-->
        加工类型：<span style="font-size: 20px;">{{ detailItem.processType }}&nbsp;代煎</span>
      </div>
      <!--中医外治-->
      <div class="flex1 row-me row-center" v-if="Number(detailItem.type)===1">
        <div style="width: 30%;">
          小袋数：<span style="font-size: 20px;">{{ detailItem.doseNums }}</span>
        </div>
        <div style="width: 25%;">快递类型：{{
            detailItem.deliveryType === 1 ? '到付' : detailItem.deliveryType === 2 ? '月结' : detailItem.deliveryType === 0 ? '寄付' : ''
          }}
        </div>
        <div style="width: 45%;">药品重量(g):{{ detailItem.totalWeight }}</div>
      </div>
      <!--其他-->
      <div class="flex1 row-me row-center" v-else>
        <div style="width: 30%;">每次服用：{{ detailItem.takeOnce }}</div>
        <div style="width: 25%;">服用天数：{{ detailItem.takeDay }}</div>
        <div style="width: 19%;">快递类型：{{
            detailItem.deliveryType === 1 ? '到付' : detailItem.deliveryType === 2 ? '月结' : detailItem.deliveryType === 0 ? '寄付' : ''
          }}
        </div>
        <div style="width: 26%;">药品重量(g):{{ detailItem.totalWeight }}</div>
      </div>
    </div>
    <div class="row-me row-center width100Per">
      <div>备注：{{ detailItem.remark ? detailItem.remark : '无' }}</div>
    </div>
    <div style="height: 310px;margin-top: 10px;">
      <div class="table-print-border">
        <div class="row-me">
          <div class="item-header width10Per" style="padding: 5px 0;">序号</div>
          <div class="item-header width35Per" style="padding: 5px 0;">药品名称</div>
          <div class="item-header width20Per" style="padding: 5px 0;">单剂量</div>
          <div class="item-header width20Per" style="padding: 5px 0;">总量</div>
          <div class="item-header width25Per" style="padding: 5px 0;">脚注</div>
          <div class="item-header width10Per" style="padding: 5px 0;">序号</div>
          <div class="item-header width35Per" style="padding: 5px 0;">药品名称</div>
          <div class="item-header width20Per" style="padding: 5px 0;">单剂量</div>
          <div class="item-header width20Per" style="padding: 5px 0;">总量</div>
          <div class="item-header width25Per" style="padding: 5px 0;">脚注</div>
        </div>
        <div class="row-me flex-wrap">
          <div class="row-me width50Per" v-for="(item,index) in drugArray" :key="index">
            <div class="item-cell width10Per" style="padding: 1px 0;">{{ index + 1 }}</div>
            <div class="item-cell width35Per" style="padding: 1px 0;">
              {{ this.$method.isEmpty(item.drugName) ? item.sourceName : item.drugName }}
            </div>
            <div class="item-cell width20Per" style="padding: 1px 0;">{{ item.preNums }}</div>
            <div class="item-cell width20Per" style="padding: 1px 0;">{{ item.nums }}</div>
            <div class="item-cell width25Per" style="padding: 1px 0;">{{ item.processMethod }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="row-me row-center" style="margin-top: 10px;">
      <div class="flex1">审核签字:</div>
      <div class="flex1">调剂签字:</div>
      <div class="flex1">复核签字:</div>
      <div class="flex1">煎药签字:</div>
      <div class="flex1">包装签字:</div>
      <div class="flex1">复核签字:</div>
    </div>
    <div class="row-me row-center flex-end1" style="margin-top: 5px;">
      {{ nowPage }}/{{ totalPage }}&emsp;共{{ totalPage }}页
    </div>
    <button v-show="false" id="printPrescriptionId" v-print="'#printPrescription'"></button>
  </div>
</template>

<script>
let JsBarcode = require('jsbarcode')
export default {
  components: {},
  props: {
    ids: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      time: '',
      detailItem: {},
      drugArray: [],
      nowPage: 1,
      totalPage: 1,
    }
  },
  // 侦听器
  watch: {},
  // 计算属性
  computed: {},
  // html加载完成之前
  created() {
    this.time = this.$method.getNowTime()
  },
  // html加载完成后执行。
  mounted() {

  },
  // 事件方法执行
  methods: {
    getDetail() {
      let i = 0
      this.startPrint(i)
    },
    startPrint(i) {
      this.$getRequest('/admin/order/getPrint/' + this.ids[i], {}).then((res) => {
        if (res) {
          this.detailItem = res.data
          //条形码
          JsBarcode("#barcode", this.detailItem.orderNo, {
            lineColor: "#000000",
            width: 2,
            height: 50,
            fontSize: 16,
            displayValue: true,
          });
          let drugs = []
          if (Number(this.detailItem.type) === 1 && this.detailItem.isCustomTransdermalDelivery) {
            if (!this.$method.isEmpty(this.detailItem.constitutes) && this.detailItem.constitutes.length > 0) {
              drugs = this.detailItem.constitutes
            } else {
              drugs = this.detailItem.drugs
            }
          } else {
            drugs = this.detailItem.drugs
          }
          let tempArray = this.$method.arraySplit(drugs, 30) //药品分页
          let j = 0;
          this.printPaging(i, j, tempArray)
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    //药品需要分页打印
    printPaging(i, j, tempArray) {
      let that = this
      this.drugArray = tempArray[j]
      this.nowPage = j + 1
      this.totalPage = tempArray.length
      setTimeout(() => {
        this.$nextTick(() => {
          document.getElementById("printPrescriptionId").click();
          if (!this.drugArray) return
          if (j === tempArray.length - 1) { //开始下一个处方打印
            i++
            if (i < that.ids.length) {
              that.startPrint(i)
            }
          } else {
            j++
            setTimeout(() => {
              that.printPaging(i, j, tempArray)
            }, 1000)
          }
        })
      }, 500)
    },
  },
}
</script>

<style lang="scss" scoped>
/*去除页眉页脚*/
@page {
  size: auto;
  /* auto is the initial value */
  margin: 3mm;
  /* this affects the margin in the printer settings */
}

html {
  background-color: #FFFFFF;
  margin: 0;
  /* this affects the margin on the html before sending to printer */
}

body {
  border: solid 1px blue;
  margin: 10mm 15mm 10mm 15mm;
  /* margin you want for the content */
}

/*去除页眉页脚*/
.printPrescription {
  font-size: 25px;
  padding: 10px 20px;

  .title {
    font-size: 30px !important;
    margin-top: 10px;
  }

  .img-code {
    width: 1200px;
    height: 300px;
    object-fit: scale-down;
  }

  .line-black {
    width: 100%;
    height: 1px;
    border-top: 1px solid #cccccc;
  }

  .table-print-border {
    border-left: 1px solid #000000;
    border-top: 1px solid #000000;

    .item-header {
      padding: 10px 0;
      border-right: 1px solid #000000;
      border-bottom: 1px solid #000000;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      word-break: break-all;
    }

    .item-cell {
      padding: 5px 0;
      border-right: 1px solid #000000;
      border-bottom: 1px solid #000000;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      word-break: break-all;
    }
  }
}
</style>
